import { render, staticRenderFns } from "./CulStatistics.vue?vue&type=template&id=5827c29c&scoped=true"
import script from "./CulStatistics.vue?vue&type=script&lang=js"
export * from "./CulStatistics.vue?vue&type=script&lang=js"
import style0 from "./CulStatistics.vue?vue&type=style&index=0&id=5827c29c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827c29c",
  null
  
)

export default component.exports